(function () {
  'use strict';

  /* @ngdoc object
   * @name entitats
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats', [
      'ui.router',
      'itecAdministracio.entitats.main'
    ]);
}());
